import get from 'lodash.get';
import { IReview } from '../p/components/page-sections/reviews/types';
import { TDocument, THeader, TPlanDetails } from './types';

export const transformPlanDetails = (
  planDetails: Partial<TPlanDetails>
): TPlanDetails => {
  return {
    active: get(planDetails, 'active', false),
    amountSymbol: get(planDetails, 'amountSymbol', ''),
    approvedReviewCount: get(planDetails, 'approvedReviewCount', 0),
    companyGSTIN: get(planDetails, 'companyGSTIN', ''),
    discountPercentage: get(planDetails, 'discountPercentage', 0),
    faq: get(planDetails, 'faq', []),
    inquiryNo: get(planDetails, 'inquiryNo', ''),
    isSearchable: get(planDetails, 'isSearchable', 0),
    listingId: get(planDetails, 'listingId', ''),
    longDescription: get(planDetails, 'longDescription', ''),
    metaDescription: get(planDetails, 'metaDescription', ''),
    name: get(planDetails, 'name', ''),
    noindex: get(planDetails, 'noindex', false),
    ogImage: get(planDetails, 'ogImage', ''),
    originalPrice: get(planDetails, 'originalPrice', 0),
    payable: get(planDetails, 'payable', false),
    planId: get(planDetails, 'planId', ''),
    price: get(planDetails, 'price', 0),
    priceBreakupTotal: get(planDetails, 'priceBreakupTotal', 0),
    process: get(planDetails, 'process', []),
    productServiceType: get(planDetails, 'productServiceType', ''),
    productDisplayOrder: get(planDetails, 'productDisplayOrder', 0),
    rating: get(planDetails, 'rating', 0),
    searchable: get(planDetails, 'searchable', false),
    seoContentBlock: get(planDetails, 'seoContentBlock', ''),
    seoContentBlockTitle: get(planDetails, 'seoContentBlockTitle', ''),
    seoDescription: get(planDetails, 'seoDescription', ''),
    seoKeywords: get(planDetails, 'seoKeywords', ''),
    seoSlug: get(planDetails, 'seoSlug', ''),
    seoName: get(planDetails, 'seoName', ''),
    servicesIncluded: get(planDetails, 'servicesIncluded', []),
    shortDescription: get(planDetails, 'shortDescription', ''),
    SKU: get(planDetails, 'SKU', ''),
    sla: get(planDetails, 'sla', 0),
    title: get(planDetails, 'title', ''),
    validPriceBreakup: get(planDetails, 'validPriceBreakup', true),
    whenRequired: get(planDetails, 'whenRequired', []),
    whoShouldUseThis: get(planDetails, 'whoShouldUseThis', []),
    youtubeURI: get(planDetails, 'youtubeURI', ''),
  };
};

export const transformDocuments = (
  documents: Array<Partial<TDocument>>
): Array<TDocument> => {
  if (!Array.isArray(documents)) return [];
  return documents.map((doc) => ({
    id: get(doc, 'id', 0),
    externalId: get(doc, 'externalId', ''),
    name: get(doc, 'name', ''),
    description: get(doc, 'description', ''),
    imageUrl: get(doc, 'imageUrl', ''),
  }));
};

export const transformReviews = (
  reviews: Array<Partial<IReview>>
): Array<IReview> => {
  if (!Array.isArray(reviews)) return [];
  return reviews.map((review) => ({
    reviewerName: get(review, 'reviewerName', ''),
    reviewText: get(review, 'reviewText', ''),
    reviewRating: get(review, 'reviewRating', ''),
  }));
};

export const transformHeaderData = (header: Partial<THeader>): THeader => {
  if (!Array.isArray(header)) return [];

  return header.map((category) => {
    let subMenu = get(category, 'subMenu', []);
    if (Array.isArray(subMenu)) {
      subMenu = transformHeaderData(subMenu);
    } else {
      subMenu = [];
    }
    return {
      categoryId: get(category, 'categoryId', ''),
      seoSlug: get(category, 'seoSlug', ''),
      name: get(category, 'name', ''),
      description: get(category, 'description', ''),
      categoryDisplayOrder: get(category, 'categoryDisplayOrder', 0),
      subMenu,
    };
  });
};
